import React from 'react';
import PropTypes from 'prop-types';

const AtSymbol = ({ color }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.9116 9.29199C16.9116 7.72492 16.4208 6.1972 15.508 4.92341C14.5952 3.64962 13.3063 2.69374 11.8224 2.19002C10.3385 1.6863 8.73408 1.66004 7.23449 2.11494C5.73489 2.56984 4.41545 3.48304 3.46147 4.72628C2.5075 5.96953 1.96691 7.48036 1.91564 9.0466C1.86436 10.6128 2.30498 12.1558 3.1756 13.4588C4.04622 14.7617 5.30311 15.7593 6.76975 16.3113C8.23638 16.8633 9.83909 16.942 11.3528 16.5364"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <ellipse cx="9.41146" cy="9.29183" rx="3.33333" ry="3.33333" stroke={color} strokeWidth="2" />
    <path
      d="M12.7451 6.79199V10.542C12.7451 11.6926 13.6779 12.6253 14.8285 12.6253V12.6253C15.979 12.6253 16.9118 11.6926 16.9118 10.542V9.29199"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

AtSymbol.propTypes = {
  color: PropTypes.string.isRequired,
};

export default AtSymbol;
